import { Link } from "react-router-dom";
import { Seo } from "../components/Seo";
import { Eyebrow, Reveal } from "../components/ui-bits";
import { CTABand, HubCard } from "../components/PageSections";
import { JOURNAL_POSTS } from "../data/site";

export default function Journal() {
  return (
    <>
      <Seo
        title="The Journal: Flower Tips from Coventry RI | JIF Flowers"
        description="Flower care tips and funeral flower etiquette guides from JIF – Jack Iannotti Flowers, Coventry, RI."
      />
      <section className="mx-auto max-w-7xl px-5 pb-16 pt-40 sm:px-8">
        <Reveal>
          <Eyebrow>The Journal</Eyebrow>
          <h1 className="mt-5 max-w-3xl font-serif text-4xl font-medium leading-[1.08] tracking-tight text-plum sm:text-5xl lg:text-6xl">
            Notes From the Flower Shop
          </h1>
          <p className="mt-6 max-w-xl text-[17px] leading-relaxed text-charcoal/85 sm:text-[18px]">
            Fifty years of flower knowledge, written down — care tips, etiquette, and seasonal guidance from the
            design bench on Main Street.
          </p>
        </Reveal>
      </section>
      <section className="mx-auto max-w-7xl px-5 pb-20 sm:px-8">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-3">
          {JOURNAL_POSTS.map((p) => (
            <HubCard
              key={p.path}
              href={p.path}
              image={p.image}
              imageAlt={p.imageAlt}
              eyebrow={p.dateLabel}
              title={p.title}
              blurb={p.excerpt}
              testid={`journal-card-${p.slug}`}
            />
          ))}
        </div>
      </section>
      <CTABand />
    </>
  );
}

export function JournalPost({ post }) {
  const articleLd = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: post.title,
    description: post.seoDescription,
    datePublished: post.date,
    author: { "@type": "Organization", name: "JIF – Jack Iannotti Flowers" },
    publisher: { "@type": "Organization", name: "JIF – Jack Iannotti Flowers" },
  };
  return (
    <>
      <Seo title={post.seoTitle} description={post.seoDescription} jsonLd={articleLd} />
      <article className="mx-auto max-w-3xl px-5 pb-20 pt-40 sm:px-8">
        <Reveal>
          <Link
            to="/journal"
            data-testid="back-to-journal"
            className="text-sm font-bold uppercase tracking-[0.14em] text-plum hover:text-berry"
          >
            ← The Journal
          </Link>
          <h1 className="mt-6 font-serif text-4xl font-medium leading-[1.1] tracking-tight text-plum sm:text-5xl">
            {post.title}
          </h1>
          <p className="mt-4 text-xs font-semibold uppercase tracking-eyebrow text-gold">{post.dateLabel}</p>
        </Reveal>
        <Reveal delay={0.1} className="mt-10">
          <img src={post.image} alt={post.imageAlt} className="aspect-[16/9] w-full rounded-xl object-cover" loading="lazy" />
        </Reveal>
        <Reveal delay={0.15} className="mt-10">
          {post.body.map((p, i) => (
            <p key={i} className="mt-6 text-[17px] leading-relaxed text-charcoal/90 first:mt-0">
              {p}
            </p>
          ))}
        </Reveal>
      </article>
      <CTABand title="Questions? The shop is a phone call away" />
    </>
  );
}
